module.exports = __webpack_public_path__ + "img/clean_black.d1c216d7.png";